export function isStorage(key) {
	let value = storageGetValue(key);
	if (value != null) {
		return true;
	}
	return false;
};

export function storageGetValue(key) {
	let value = localStorage.getItem(key);
	return value;
};

export function storageSetValue(key, value) {
	localStorage.setItem(key, value);
};

export function storageDeleteValue(key) {
	localStorage.removeItem(key);
};


export function historySave(url, title) {
	window.on_modal_close_url = url;
	window.on_modal_close_title = title;
}

export function historySet(previous, current, title) {
	window.history.pushState({}, '', previous);
	window.history.replaceState({}, '', current);
	document.title = title;
}

export function historyRestore() {
	window.history.pushState({}, '', document.location.href);
	window.history.replaceState({}, '', window.on_modal_close_url);
	document.title = window.on_modal_close_title;
}

export function loading() {
	// document.body.classList.toggle('loading');
}

export function toggleScroll() {
	document.body.classList.toggle('disable-scroll');
}

export function disableScroll() {
	document.body.classList.add('disable-scroll');
}

export function enableScroll() {
	document.body.classList.remove('disable-scroll');
}

export function clickOut (e, target, callback) {
	if (!target.contains(e.target)) callback();
};

export function trapFocus(el) {

	document.body.addEventListener('keydown', trap);

	function trap(e, to_trap = el) {
		var focusable_els = to_trap.querySelectorAll(`
			a[href]:not([disabled]),
			button:not([disabled]),
			textarea:not([disabled]),
			input[type="text"]:not([disabled]),
			input[type="radio"]:not([disabled]),
			input[type="checkbox"]:not([disabled]),
			select:not([disabled])`
		);

		var filtered_focusable_els = [];



		focusable_els.forEach((el) => {
			if (!el.closest('.modal-hide') && !el.closest('.d-none')) {
				filtered_focusable_els.push(el);
			}
		});

		var first_focusable_el = filtered_focusable_els[0];  
		var last_focusable_el = filtered_focusable_els[filtered_focusable_els.length - 1];
		var keycode_tab = 9;

		var is_tab_pressed = (e.key === 'Tab' || e.keyCode === keycode_tab);

		if (!is_tab_pressed) { 
			return; 
		}

		if (e.shiftKey) {
			if (document.activeElement === first_focusable_el) {

					last_focusable_el.focus();


				e.preventDefault();
			}
		} else {
			if (document.activeElement === last_focusable_el) {


				first_focusable_el.focus();
				
				e.preventDefault();
			}
		}
	}
}